export default __webpack_public_path__ + "static/media/franchise-hero.3e7c3d95.png";